import React from 'react';
import { motion } from 'framer-motion';
const before = ['Mensaje', 'Persona responde', 'Copia información', 'Actualiza CRM', 'Pregunta disponibilidad', 'Busca calendario', 'Confirma', 'Recuerda', 'Hace seguimiento'];
const withOrigen = ['Mensaje', 'IA', 'Calificación', 'CRM', 'Agenda', 'Seguimiento'];
export function ResultSection() {
  return <section id="resultados" className="bg-arena py-[44px] md:py-[64px]" data-id="element-250" data-mp="29882s62291bs">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-251" data-mp="29aas0nve2qfg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="text-center max-w-[560px] mx-auto mb-10" data-id="element-252" data-mp="24apt2dg7yi2q">
          <h2 className="font-display text-[28px] md:text-[38px] font-bold text-carbon leading-[1.1]" data-id="element-253" data-mp="2s00xc4ws2ulm">
            Menos tareas repetitivas. Más procesos funcionando.
          </h2>
        </motion.div>

        <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-254" data-mp="2gpxwfqox86ut">
          <div aria-hidden="true" className="hidden md:flex absolute left-1/2 top-0 bottom-0 -translate-x-1/2 items-center justify-center w-8" data-id="element-255" data-mp="2kqq4igm245pi">
            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-verde/10 text-verde" data-id="element-256" data-mp="2bxwmwcj50u8h">
              →
            </span>
          </div>
          {/* ANTES */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          ease: 'easeOut'
        }} className="md:pr-4" data-id="element-257" data-mp="1x38iz2tdy3uz">
            <span className="block font-body text-[10px] uppercase font-medium text-carbon/35 tracking-[0.15em] mb-4" data-id="element-258" data-mp="1szu1s8tpnhfy">
              ANTES
            </span>
            <div className="flex flex-wrap gap-1.5" data-id="element-259" data-mp="3nduzurhfs0ez">
              {before.map((step, idx) => <motion.span key={step} initial={{
              opacity: 0,
              y: 6
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              ease: 'easeOut',
              delay: 0.1 + idx * 0.05
            }} className="font-body text-[12px] text-carbon/50 bg-carbon/5 rounded-[8px] px-3 py-1.5" data-id="element-260" data-mp="3kz6d7b1ucy0v" data-mpi={idx}>
                  {step}
                </motion.span>)}
            </div>
          </motion.div>

          {/* CON ORIGEN */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: 0.08
        }} className="md:pl-4" data-id="element-261" data-mp="3kj4rj54jkcl">
            <span className="block font-body text-[10px] uppercase font-medium text-verde tracking-[0.15em] mb-4" data-id="element-262" data-mp="r9u7h661botd">
              CON ORIGEN
            </span>
            <div className="flex flex-wrap gap-1.5" data-id="element-263" data-mp="tt8qcwyogzxw">
              {withOrigen.map((step, idx) => <motion.span key={step} initial={{
              opacity: 0,
              scale: 0.92
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              ease: 'easeOut',
              delay: 0.35 + idx * 0.08
            }} className="font-body text-[13px] font-medium text-arena bg-verde rounded-[8px] px-3.5 py-1.5" data-id="element-264" data-mp="ysbixhxh1doz" data-mpi={idx}>
                  {step}
                </motion.span>)}
            </div>
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.35,
        delay: 0.15
      }} className="text-center font-display text-[16px] md:text-[18px] font-semibold text-carbon mt-10 max-w-[520px] mx-auto" data-id="element-265" data-mp="1rfo53qzpzjhr">
          La automatización no reemplaza tu operación. La hace funcionar
          mejor.
        </motion.p>
      </div>
    </section>;
}